import {
    type UpdateUserResponseType,
    type UpdateUserRequestType
} from "./type";
import {
    request
} from "../request";

const UpdateUser = async (params: UpdateUserRequestType): Promise<UpdateUserResponseType> => {
    return await request<UpdateUserResponseType>("/user/updateUser", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default UpdateUser;
